import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={'100%'}
    height={3}
    fill="none"
    {...props}
  >
    <path
      stroke="url(#abzbzx)"
      strokeLinecap="round"
      strokeWidth={2}
      d="m-8 1.748 1935-.003"
    />
    <defs>
      <linearGradient
        id="abzbzx"
        x1={242.624}
        x2={887.001}
        y1={1.301}
        y2={1.549}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDCFA2" />
        <stop offset={0.095} stopColor="#8C866B" />
        <stop offset={0.24} stopColor="#8C866A" />
        <stop offset={0.475} stopColor="#F5E6B6" />
        <stop offset={0.62} stopColor="#8C866B" />
        <stop offset={0.86} stopColor="#8C866B" />
        <stop offset={1} stopColor="#A59A87" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
